module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/13UvhCy/image/cover.jpg?1706297465157",
      "alt": "This image is the cover for the book Escape Manual for Introverts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Escape Manual for Introverts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Trapped in an airplane seated next to a chatterbox? Are you hosting a dinner party with people who just won't leave? Katie Vaz has the key to your escape. "), _c('i', [_vm._v("The Escape Manual for Introverts")]), _vm._v(" guides readers through different scenarios with themed chapters (\"Friends,\" \"Relatives,\" \"Strangers,\" etc.). Each chapter covers a range of situations, from an invitation to karaoke night to group lunchtime. And she offers a number of escapes for each scenario: bringing odoriferous foods to lunch for a while, having a pet (real or imagined) that \"requires\" frequent check-ins, and even investing in a jet pack. This book features Vaz's full-page illustrated spreads, hand-lettering, and spot illustrations. From the silly to the sincere, Vaz's clever, hilarious escape plans and bizarre excuses speak to the introvert in all of us. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Katie Vaz\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0